import BusinessInputs from "../../../components/BusinessInputs";
import UserInputs from "../../../components/UserInputs";

const BillableResellerDetails = ({ businessName, businessAddress, userFirstName, userLastName, userEmail, onChangeInput, title }) => {
	return (
		<div>
			{(!title.startsWith("Edit")) && <p className="mb-6">Please add the details below for your new reseller. You should confirm with them which email to use.</p>}
			<BusinessInputs
				nameLabel="Business Name"
				name={businessName}
				addressLabel="Business Address"
				address={businessAddress}
				onChangeInput={onChangeInput}
			/>
			<UserInputs 
				nameLabel="Primary Contact"
				firstName={userFirstName}
				lastName={userLastName}
				emailLabel="Primary Contact Email"
				email={userEmail}
				onChangeInput={onChangeInput}
			/>
		</div>
	);
};

export default BillableResellerDetails;